function _typeof(o) {
  '@babel/helpers - typeof';
  return (
    (_typeof =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (o) {
            return typeof o;
          }
        : function (o) {
            return o &&
              'function' == typeof Symbol &&
              o.constructor === Symbol &&
              o !== Symbol.prototype
              ? 'symbol'
              : typeof o;
          }),
    _typeof(o)
  );
}
var _excluded = [
  'menu',
  'switcherIconPosition',
  'switcherIcon',
  'fieldNames',
  'titleRender',
  'treeNodeActionMenuTrigger',
  'highlightKeyword',
  'getPopupContainer',
];
var _templateObject, _templateObject2;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r &&
      (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })),
      t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2
      ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : ownKeys(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, 'string');
  return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}
import React, { useEffect, useMemo, useRef } from 'react';
import { Button, Icon } from 'udesk-ui';
import styled from 'styled-components';
import { highlight } from '../../utils';
import { MoreOutlined } from '@udesk/icons';
import BatchedActions from '../../batched-actions';
var highlightText = highlight.highlightText,
  clearHighlight = highlight.clearHighlight;
var HIGHLIGHT_CLASS_NAME = 'udsek-gm-ui-tree-menu__tree-node--highlight';
var TreeNodeTitle = styled.div(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteral([
      '\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding-right: 16px;\n  flex: 1;\n',
    ])),
);
var TreeNodeWrap = styled.div(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteral([
      '\n  display: flex;\n  justify-content: space-between;\n  .',
      ' {\n    color: red;\n  }\n  .batched-actions-dropdown {\n    opacity: 0;\n  }\n  &:hover {\n    .batched-actions-dropdown {\n      opacity: 1;\n    }\n  }\n',
    ])),
  HIGHLIGHT_CLASS_NAME,
);
var DEFAULT_FIELD_NAMES = {
  title: 'title',
  key: 'key',
  children: 'children',
};
var defaultConfirm = {
  icon: /*#__PURE__*/ React.createElement(Icon, {
    type: 'ExclamationCircleOutlined',
    antdIcon: true,
  }),
};
var TreeNode = function TreeNode(props) {
  var _props$menu = props.menu,
    menuProps = _props$menu === void 0 ? [] : _props$menu,
    switcherIconPosition = props.switcherIconPosition,
    switcherIcon = props.switcherIcon,
    customizeFieldNames = props.fieldNames,
    titleRender = props.titleRender,
    treeNodeActionMenuTrigger = props.treeNodeActionMenuTrigger,
    highlightKeyword = props.highlightKeyword,
    getPopupContainer = props.getPopupContainer,
    node = _objectWithoutProperties(props, _excluded);
  var treeNodeInstance = useRef(null);
  var hiddenExtra = useMemo(
    function () {
      return menuProps.every(function (item) {
        return typeof item.disabled === 'function' ? item.disabled(node) : item.disabled;
      });
    },
    [menuProps, node],
  );
  var fieldNames = useMemo(
    function () {
      return Object.assign({}, DEFAULT_FIELD_NAMES, customizeFieldNames);
    },
    [customizeFieldNames],
  );
  var isLeaf = useMemo(
    function () {
      return !hasChildren(node, fieldNames.children);
    },
    [node, fieldNames.children],
  );
  useEffect(
    function () {
      treeNodeInstance.current && clearHighlight(treeNodeInstance.current);
      if (highlightKeyword) {
        treeNodeInstance.current &&
          highlightText(treeNodeInstance.current, highlightKeyword, {
            className: HIGHLIGHT_CLASS_NAME,
          });
      }
    },
    [highlightKeyword],
  );
  return /*#__PURE__*/ React.createElement(
    TreeNodeWrap,
    {
      ref: treeNodeInstance,
    },
    /*#__PURE__*/ React.createElement(
      TreeNodeTitle,
      {
        className: 'tree-node-title',
        title: typeof node[fieldNames.title] === 'string' ? node[fieldNames.title] : undefined,
      },
      typeof titleRender === 'function' ? titleRender(node) : node[fieldNames.title],
    ),
    /*#__PURE__*/ React.createElement(
      'div',
      {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
      },
      hiddenExtra ||
        /*#__PURE__*/ React.createElement(
          BatchedActions,
          _objectSpread(
            {
              menu: menuProps,
              trigger: treeNodeActionMenuTrigger,
              getPopupContainer: getPopupContainer,
            },
            node,
          ),
          /*#__PURE__*/ React.createElement(Button, {
            size: 'small',
            type: 'text',
            icon: /*#__PURE__*/ React.createElement(MoreOutlined, null),
          }),
        ),
    ),
    switcherIconPosition === 'right' &&
      /*#__PURE__*/ React.createElement(
        'div',
        {
          className: 'switcher-icon-right',
        },
        !isLeaf &&
          (switcherIcon ||
            /*#__PURE__*/ React.createElement(Icon, {
              type: 'DownOutlined',
              antdIcon: true,
            })),
      ),
  );
};
export { TreeNode };
function hasChildren(node, childrenPropsName) {
  return Array.isArray(node[childrenPropsName]) && node[childrenPropsName].length > 0;
}
